import type { ReactiveController, ReactiveControllerHost } from "lit";

export class NudgeController implements ReactiveController {
  private host: ReactiveControllerHost;
  showNudge = false;
  nudgeText = "Click to chat";
  private nudgeTimeoutId?: number;
  private nudgeAutoHideId?: number;

  constructor(host: ReactiveControllerHost) {
    this.host = host;
    host.addController(this);
  }

  hostDisconnected(): void {
    this.clearTimers();
  }

  schedule(initialDelayMs = 3500, autoHideMs = 7000): void {
    try {
      this.nudgeTimeoutId = window.setTimeout(() => {
        if (!this.showNudge) {
          this.showNudge = true;
          this.host.requestUpdate();
          this.nudgeAutoHideId = window.setTimeout(() => {
            this.showNudge = false;
            this.host.requestUpdate();
          }, autoHideMs);
        }
      }, initialDelayMs);
    } catch {}
  }

  dismiss(e?: Event): void {
    if (e) e.stopPropagation();
    this.showNudge = false;
    this.clearTimers();
    this.host.requestUpdate();
  }

  setText(text: string): void {
    if (text && text.trim()) {
      this.nudgeText = text.trim();
      this.host.requestUpdate();
    }
  }

  clearTimers(): void {
    try {
      if (this.nudgeTimeoutId) window.clearTimeout(this.nudgeTimeoutId);
      if (this.nudgeAutoHideId) window.clearTimeout(this.nudgeAutoHideId);
    } catch {}
    this.nudgeTimeoutId = undefined;
    this.nudgeAutoHideId = undefined;
  }
}
